/* template */
<template><es-layout :layout="(['header', 'footer'])" :esMainStyle="(esMainStyle)" :useDefaultNavbar="(false)" :navbarClickLeft="(goback)" :custom-class='["backgroundConent"].join(" ")'><template v-if="(!isMini)"><div slot="header" class="navbarBg"><es-navbar :onClickLeft="(goHome)"></es-navbar></div></template><div class="backgroundStyle"><banner :title="(bannerTitle)" :class="(loginPageStatus?.quickLogin && 'quick')" class="banner"></banner><template v-if="(loginPageStatus.alreadyLogin)"><passengers/><cxvip-card :isCxvip="(loginPageStatus.isCxvip)"/></template><div class="es-login-form"><template v-if="(loginPageStatus.commonLogin || loginPageStatus.changeUser)"><div class="es-login-input"><mpx-input type="text" ref="name" placeholder="12306用户名/邮箱/手机号" :value="inputdata" mpxModelEvent="input" @mpxModel='__model("inputdata", $event, ["value"], undefined)' class="inputStyle"/></div><div class="es-login-input"><mpx-input :type="(passwordType)" ref="password" :style="[(fontSizeAdapt)] | transRpxStyle" placeholder="请输入12306密码" :value="passWordData" mpxModelEvent="input" @mpxModel='__model("passWordData", $event, ["value"], undefined)' class="inputStyle"/><mpx-view @tap="eyehandle" class="icon-eye-close"><template v-if="(!eyeState)"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/LpvhCITOpN1642147541419.png" class="es-eye"></mpx-image></template><template v-else><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/FLGAZitaXS1642147590072.png" class="es-eye"></mpx-image></template></mpx-view></div><div class="es-login-input" v-if="(accountChannel !== 'app')"><mpx-input type="text" ref="digit" placeholder="请输入登录账号绑定的证件号后四位" :value="digitdata" mpxModelEvent="input" @mpxModel='__model("digitdata", $event, ["value"], undefined)' class="inputStyle"/></div><div class="form-block"></div></template><div class="es-rm-agree-box" v-if="(!loginPageStatus.alreadyLogin)"><div class="es-login-agree-left"><div class="es-rm-agreement"><es-checkbox-group :value="checkboxValue" mpxModelEvent="input" @mpxModel='__model("checkboxValue", $event, ["value"], undefined)' direction="row"><es-checkbox label-position="right" name="1" shap="square" :iconSize="(16)" :icon-style="({borderRadius: '6px'})" :useIconSlot="(true)" color="#338FFF"><mpx-image mode="aspectFit" slot="icon" src="https://ut-static.udache.com/webx/sfc/f2m654Y-v5zvwcBCQw1aO.png" class="es-zdy-icon" v-if="(statusCheckout)"></mpx-image><div class="es-rm-checkbox">我阅读并同意以下协议<mpx-view @tap="goto" class="es-rm-navigator highlight es-line">《个人信息处理授权协议》</mpx-view></div></es-checkbox></es-checkbox-group></div></div><mpx-view @tap="goNext" class="es-rm-navigator" v-if="(loginPageStatus.commonLogin || loginPageStatus.changeUser)">忘记密码</mpx-view></div><mpx-view @tap="quickLoginHandle" class="buttonStyle login" v-if="(loginPageStatus.quickLogin)">一键登录12306</mpx-view><mpx-view @tap="submit" class="buttonStyle login" v-if="(loginPageStatus.commonLogin || loginPageStatus.changeUser)">登录12306</mpx-view><mpx-view @tap="goRegister" class="buttonStyle register" v-if="(loginPageStatus.commonLogin)">没有账号？30s极速注册</mpx-view><historyAccount class="history-account" v-if="(loginPageStatus.changeUser)"></historyAccount></div></div><div slot="footer" class="quick-entrance" v-if="(quickEntrance && !isFoucs)"><mpx-view v-for="(item, index) in (quickEntrance)" @tap="item.cb" class="entrance-item">{{
        item.text
      }}</mpx-view></div><es-riskmanagement loginType="login"></es-riskmanagement><es-dialog id="es-dialog-conceal"><div slot="content"><div class="protocol text">我阅读并同意以下协议</div><mpx-view @tap="goto" class="protocol url">《个人信息处理授权协议》</mpx-view><div class="protocol text">同意受本协议约束</div></div></es-dialog><cxvip-popup/></es-layout></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m7e8c4787"}'>
  @import '~@/mixins/stylus/color.styl'

  /deep/ .es-dialog__confirm
    color #338FFF !important
  .protocol
    font-size 14px
    display inline
    line-height 17px
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color $train-color-666
    &.url
      color #338FFF
  .navbarBg
    background-color $train-color-fff
  .backgroundConent
    background-color #FFFFFF
    height 100%
  .es-rm-agree-box
    display flex
    justify-content space-between
    .es-login-agree-left
      display flex
      align-items center
      flex 1
      flex-wrap wrap
      .es-rm-agreement
        >>> .es-rm-checkbox
          color #666
        >>> .es-checkbox--checked
          border none
    .es-rm-navigator
      display flex
      align-items center
      font-size 12px !important
      line-height 1
      color #000
      text-decoration none
      letter-spacing 0
      &.highlight
        color #338FFF
      &.es-line
        display inline
  .es-rm-checkbox
    font-size 12px
    color $train-color-999
    margin-left -5px
  .buttonStyle
    box-sizing border-box
    height 48px
    font-size 16px
    border-radius 8px
    font-family PingFangSC-Medium
    font-weight normal
    line-height 1
    letter-spacing 0
    display flex
    align-items center
    justify-content center
    &.login
      color #fff
      background #338FFF
      margin-top 12px
    &.register
      color #338FFF
      border 1px solid #338FFF
      margin-top 12px
  .backgroundStyle
    padding 19px 24px 24px
    background-color #FFFFFF
    .banner
      margin-bottom 37px
      &.quick
        margin-bottom 53px
    .history-account
      margin-top 32px
  .inputStyle
    font-size 16px
    outline none
    flex 1
    height 20px
    font-family PingFangSC-Medium
    font-weight normal
    line-height 1
    letter-spacing 0px
    color #000000
    -webkit-tap-highlight-color transparent
    &::placeholder
      font-family PingFangSC-Regular
      font-size 16px
      font-weight normal
      line-height 1
      letter-spacing 0px
      color #999999
  .es-login-input
    height 56px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px #EEEEEE solid
    position relative
    .icon-eye-close
      flex none
      margin-left 8px
      @extend .expand-click
      width 20px
      height 20px
      .es-eye
        width 16px
        height 16px
  .form-block
    height 24px
  .es-zdy-icon
    width 16px
    height 16px
  .quick-entrance
    padding-bottom 57px
    box-sizing border-box
    width 100%
    display flex
    align-items center
    justify-content center
    .entrance-item
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      height 24px
      letter-spacing 0px
      color #000000
      margin 0 30px
      position relative
      &+.entrance-item
        margin-left 31px
        &::before
          content ''
          position absolute
          left -30px
          top 3px
          width 1px
          height 10px
          background-color #999
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m7e8c4787"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m7e8c4787"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-checkbox':getComponent(require("../../es-mpx-ui/lib/checkbox/index.mpx?isComponent&outputPath=components%2Findex8e1a7e44%2Findex")),'es-riskmanagement':getComponent(require("./components/rm/risk-management.mpx?isComponent&outputPath=components%2Frisk-management0659070a%2Findex")),'banner':getComponent(require("./components/common/banner.mpx?isComponent&outputPath=components%2Fbanner4ff8d9a0%2Findex")),'historyAccount':getComponent(require("./components/common/history-account.mpx?isComponent&outputPath=components%2Fhistory-account4c009f1e%2Findex")),'passengers':getComponent(require("./components/common/passengers.mpx?isComponent&outputPath=components%2Fpassengers645f23c6%2Findex")),'cxvip-card':getComponent(require("./components/common/cxvip-card.mpx?isComponent&outputPath=components%2Fcxvip-card6f4f6739%2Findex")),'cxvip-popup':getComponent(require("./components/common/cxvip-popup.mpx?isComponent&outputPath=components%2Fcxvip-popup6722e351%2Findex")),'es-checkbox-group':getComponent(require("../../es-mpx-ui/lib/checkbox-group/index.mpx?isComponent&outputPath=components%2Findex5f7ef460%2Findex")),'es-layout':getComponent(require("../../es-mpx-ui/lib/layout/index.mpx?isComponent&outputPath=components%2Findex2146c876%2Findex")),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
